import React from 'react';
import { Link } from 'react-router-dom';
import { Modal } from './Modal';
import { useTranslation } from '../i18n';
import { AccountTab, buildAccountLink } from '../utils/accountRedirect';

interface AccountActionModalProps {
  open: boolean;
  onClose: () => void;
  message: string;
  /** Account tab that resolves the issue. */
  tab?: AccountTab;
}

export const AccountActionModal: React.FC<AccountActionModalProps> = ({
  open,
  onClose,
  message,
  tab,
}) => {
  const { t } = useTranslation();
  const accountTo = buildAccountLink(tab);

  return (
    <Modal open={open} onClose={onClose} title={t('account.action_required_title')}>
      <p style={{ marginTop: 0 }}>{message}</p>
      <div className="form-actions">
        <Link to={accountTo} className="btn btn-accent" onClick={onClose}>
          {t('manage.connect_required_link')}
        </Link>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          {t('rental.cancel')}
        </button>
      </div>
    </Modal>
  );
};
